export enum BriefListViewType {
  GRID_VIEW = "grid_view",
  LIST_VIEW = "list_view",
}
